// stahlia-frontend/src/lib/sku-list.ts
/** Korrektur #13: Excel-Paste einer Nummern-Spalte → normalisierte Liste.
 *  Trenner: Zeilenumbruch, Komma, Semikolon, Tab. Trim + Dedup, Reihenfolge stabil. */
export function parseSkuPaste(text: string): string[] {
  return Array.from(new Set(
    text.split(/[\n\r,;\t]+/).map((s) => s.trim()).filter((s) => s.length > 0),
  ));
}
